<template>
  <div class="pa-4 custome-border-component fixed-height-comp">
    <!-- Header -->
    <v-row class="page-header mt-0">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold custom-title">{{$t('lbl.admin.recent_system_errors')}}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :class="['list-table admin-process-style srm-list-table custom-border-table', listData.length > 0 ? '' : 'custom-border-table-not-data']"
          :fixed-header="true"
          hide-default-footer
          :height="tableHeight"
          disable-pagination
          disable-sort
        >
          <template v-slot:item.timestamp="{ item }">
            <font>{{applyGmtTimeZone(item.timestamp)}}</font>
          </template>
          <template v-slot:item.logLevel="{ item }">
            <a
              class="link-error-text cursor-pointer layout-col"
              @click="openErrorMessageWindow(item.message)"
            >{{$t('btn.common.error')}}</a>
          </template>
          <template v-slot:item.processId="{ item }">
            <font class="link-file-text cursor-pointer layout-col">{{item.processId}}</font>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <ErrorMessage
        v-if="dialog.type == 'errorMessageWindow'"
        :id="dialog.id"
        title="Error Message"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :errorMessage="dialog.item.data"
      ></ErrorMessage>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import ErrorMessage from "@/vue-caas/views/admin/ErrorMessageView.vue";

const moment = require("moment");
export default {
  components: {
    ErrorMessage,
  },
  data() {
    return {
      isCreated: false,
      dialogs: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialog: false,
      listData: [],
      tableHeight: "",
      headers: [
        {
          text: "Owner ID",
          value: "groupId",
          width: "130px",
          sortable: false,
        },
        {
          text: "Company ID",
          value: "userId",
          width: "130px",
          sortable: false,
        },
        {
          text: "Process ID",
          value: "processId",
          width: "150px",
          sortable: false,
        },
        {
          text: "Module ID",
          value: "emitterId",
          width: "180px",
          sortable: false,
        },
        {
          text: "Error Code",
          value: "errorCode",
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          text: "Error Desc.",
          value: "logLevel",
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          text: "Date & Time",
          value: "timestamp",
          align: "center",
          width: "160px",
          sortable: false,
        },
      ],
      gmtTmzn: "",
    };
  },

  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 285 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 285 + "px";
    });
  },

  created() {
    this.searchData();
    this.isCreated = true;
  },
  methods: {
    searchData() {
      this.gmtTmzn = this.$cookies.get("gmt-timezone");
      const params = {
        ownrId : this.$cookies.get("ownr-id")
      }
      this.$store
        .dispatch("getRecentSystemErrorsData", params)
        .then(() => {
          this.listData = this.$store.getters.recentSystemErrorsData;
          console.log(this.listData)
        })
        .catch((ex) => {});
    },
    applyGmtTimeZone(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        newM = moment.utc(date)
          .add(this.gmtTmzn, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },
    openErrorMessageWindow(message) {
      let type = "errorMessageWindow";
      let item = {
        ROWID: 0,
        data: message,
      };
      let indexArrDialog = this.findDialog("errorMessageWindow_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = "Dialog " + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, item, options };
    },
    selectDialog(obj) {
      console.log(obj);
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, "left", obj.left);
      this.$set(this.dialogs[index].options, "top", obj.top);
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
  },
};
</script>

<style>
</style>